import { useIonRouter, IonGrid, IonCol, IonRow, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useState } from "react";

import './Main.css'; 

import NServer from "../components/NServer";
import { LANGUAGE, GetStr } from "../language/Language";
import Vault from '../components/Vault';
import { showAlert } from '../components/Alert';

const ChangeChatName : React.FC = () => {

    const [ name, setName] = useState("");
    const [ nameValid, setNameValid ] = useState(false);

    const router = useIonRouter();

    // handle the user input
    const checkInput = (e : any ) : void => {
        setName(e.detail.value.toString());
        setNameValid(e.detail.value.length > 5);
    };

    // change the name
    const changeName = async () => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            p1 : "chat",
            p2 : name
        }

        var server = new NServer();
        await server.sendForm("change_info", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            router.push("/messages", "back", "pop");
        }
    }

    return (
        <IonPage>
            <IonContent>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton text="" defaultHref="/profile" ></IonBackButton>
                    </IonButtons>
                    <IonTitle className="title"><h5>{GetStr(LANGUAGE.TXT_CHAT_NAME_TITLE)}</h5></IonTitle>
                </IonToolbar>
                <IonGrid className="ion-no-padding main-content">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="8" size-lg="6" size-xl="4" size="12">
                            <IonCard className="ion-padding flat-card">
                                <IonItem >
                                    <IonLabel position="floating">{GetStr(LANGUAGE.TXT_CHAT_NAME_DESC)}</IonLabel>
                                    <IonInput type="email" value={name} onIonChange={ checkInput }></IonInput>
                                </IonItem>
                                <br/>
                                <IonButton className="ion-margin-top main-but" color="primary" expand="block" onClick={changeName} disabled={!nameValid}>
                                    {GetStr(LANGUAGE.TXT_CHAT_NAME_BUT)}
                                </IonButton>
                            </IonCard>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
    );

};

export default ChangeChatName;